"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIAutosizedTextInput = _interopRequireDefault(require("UIComponents/input/UIAutosizedTextInput"));

var _ScopedFeatureTooltip = _interopRequireDefault(require("FileManagerCore/components/permissions/ScopedFeatureTooltip"));

var FilenameInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FilenameInput, _Component);

  function FilenameInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FilenameInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FilenameInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.inputRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(FilenameInput, [{
    key: "blur",
    value: function blur() {
      if (this.inputRef.current) {
        this.inputRef.current.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          error = _this$props.error,
          value = _this$props.value,
          onBlur = _this$props.onBlur,
          onKeyDown = _this$props.onKeyDown,
          isReadOnly = _this$props.isReadOnly;
      return _react.default.createElement(_ScopedFeatureTooltip.default, null, _react.default.createElement("span", {
        className: (0, _classnames.default)('filename-input', 'is--heading-7 m-left-2 m-bottom-4 m-right-8', {
          'is-read-only': isReadOnly
        })
      }, _react.default.createElement(_UIAutosizedTextInput.default, {
        inputRef: this.inputRef,
        affordance: true,
        onChange: onChange,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        value: value,
        error: error,
        disabled: isReadOnly
      })));
    }
  }]);
  return FilenameInput;
}(_react.Component);

exports.default = FilenameInput;
FilenameInput.propTypes = {
  error: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func.isRequired,
  onKeyDown: _propTypes.default.func.isRequired,
  value: _propTypes.default.string.isRequired,
  isReadOnly: _propTypes.default.bool.isRequired
};
module.exports = exports.default;